// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2zlK3","disabled":"FileBtn_disabled__2FZgR","warn":"FileBtn_warn__2DA6e","fade":"FileBtn_fade__3XgRB"};